// extracted by mini-css-extract-plugin
module.exports = {"infoBlock":"infoBlock_infoBlock__2WANV","title":"infoBlock_title__V8InH","content":"infoBlock_content__3HZBD","noDataAvailable":"infoBlock_noDataAvailable__s0HIV"};